import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { essentialWordsData, getDataForDifficulty } from '../courses/data/vocabulary/essentialWords';

export default function EssentialWordsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : essentialWordsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
